import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useEnabledAssistants } from '~/api'
import { AppDisabled } from '~/components/student/app/AppDisabled'
import { useCourseId } from '~/hooks/useCourseId'

export const Route = createFileRoute('/student/courses/$courseId/')({
	component: CourseIndex,
})

function CourseIndex() {
	const courseId = useCourseId()
	const enabledApps = useEnabledAssistants()
	const navigate = useNavigate()

	function redirectToApp(appId: string) {
		void navigate({
			from: '/student/courses/$courseId',
			to: '/student/courses/$courseId/apps/$appId',
			params: { appId },
		})
	}

	useEffect(() => {
		if (enabledApps.length > 0) {
			redirectToApp(enabledApps[0].id)
		}
	}, [enabledApps, courseId])

	if (enabledApps.length === 0) {
		return <AppDisabled />
	}

	return null
}
